<template>
    <div>
        <NavTop/>
        <NavDark/>

        <div class="gray py-3 mt-3">
            <div class="container">
                <div class="row">
                    <div class="colxl-12 col-lg-12 col-md-12">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to="/">Velkommen</router-link></li>
                                <li class="breadcrumb-item active" aria-current="page">Opret webshop</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div> 
        </div>

        <section class="middle">
            <div class="container">
                <div class="row ">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">

                        <div class="sec_title position-relative text-center">
                            <div class="sec_title position-relative text-center" data-bgtext="Opret Webshop">
                                <h3 class="ft-bold pt-3">Opret Webshop</h3>
                            </div>
                        </div>

                        <div class="abt_caption">
                        
                            <p class="mb-4">
                                Drømmer du også om at få dine værker eller designprodukter ud til flere mennesker?<br />Yoko.dk er Danmarks største og mest inspirerende markedsplads for kunsthåndværk.<br />
                                </p>

                                <h2 class="ft-medium mb-4">Sådan fungerer det</h2>
                            <p class="mb-4">Yoko.dk er en del af Shup.dk<br />
                                Shup er en <a href="https://system.shup.dk/createAccount" title="Opret webshop på shup.dk">ultra simpelt webshop platform</a> hvor hundredevis af danske kunstnere og designere har deres webshop - på deres eget domæne.<br /><br />
                                Som en ekstra service, har alle, der har en webshop på shup.dk, også mulighed for at sætte produkterne til salg på Yoko.dk. Det gør man blot ved at markere et flueben ud for et produkt, inde på shup.dk<br /><br />
                                Dvs. når du opretter en webshop på shup.dk, får du både din egen webshop - på dit eget domæne - og samtidig en profil på Danmarks største webshop for kunsthåndværk, Yoko.<br /><br />Hva' så, skal vi i gang?
                                
                                </p>
                                <h2>Sådan kommer du i gang</h2><br />



<h3>1) <a href="https://system.shup.dk/createAccount" title="Opret webshop på shup.dk" style="text-decoration: underline;">Opret din webshop på Shup.dk</a></h3>
<p class="mb-4">Det er ultra simpelt at oprette en webshop på shup.dk og kræver ingen teknisk forståelse.</p>

<h3>2) Tilføj dine værker inde på shup.dk</h3>
<p class="mb-4">Når webshoppen er oprettet, tilføjer du dine værker med billeder, priser osv.</p>

<h3>3) Vælg om de skal vises på Yoko.dk</h3>
<p class="mb-4">Når dine værker er tilføjet, markerer du at de skal sættes til salg på Yoko.dk<br /><b>Voilá!</b></p>

<p class="mb-4">
<b>OBS: Er du allerede SHUP bruger, kan du blot logge ind på shup.dk og markere hvilke af dine produkter, du ønsker vist på Yoko.dk</b></p>
<br />
Bliv en del af fællesskabet
Vælger du at dele dine produkter på Yoko.dk, bliver du en del af et stærkt fællesskab af udvalgte kunsthåndværkere. Du bevarer din egen webshop og profil, men får samtidig ekstra synlighed og flere salgsmuligheder gennem YOKO.



                          
                            <div class="form-group mt-4">
                                <router-link to="https://system.shup.dk/createAccount" class="btn btn-dark">Opret din webshop på shup.dk</router-link>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div class="abt_caption">
                            <img :src="about1" class="img-fluid rounded border" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterTopTwo/>
        <FooterDark/>
        <ScrollToTop/>

    </div>
</template>

<script setup>
    import about1 from '@/assets/img/about-1.png'
  
    
    import FooterDark from '@/components/footer/footer-dark.vue';
    import FooterTopTwo from '@/components/footer/footer-top-two.vue';
    import NavDark from '@/components/navbar/nav-dark.vue';
    import NavTop from '@/components/navbar/nav-top.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
</script>




